import axios from "axios";
axios.defaults.withCredentials = true;

axios.interceptors.response.use(Promise.resolve(), function (error) {
  if (error.response.status === 403) {
    alert("Request Is Forbidden. Contact Administrator");
  }
  return Promise.reject(error);
});

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

let baseHref;
if (process) {
  baseHref = process.env.REACT_APP_API_BASE_HREF;
}

export const endPoint = (type, query = null) => {
  const url = `${baseHref}${type}`;
  const queryString = new URLSearchParams({ ...query });

  if (query) {
    return `${url}?${queryString.toString()}`;
  }
  return url;
};

export const extract = (r) => r.data;

export const parseResult = (data) => {
  if (!data.result) {
    if (isJsonString(data.error.message)) {
      // eslint-disable-next-line no-throw-literal
      throw {
        ...data.error,
        message: JSON.parse(data.error.message)?.err || data.error.message,
      };
    }
    throw data.error;
  }

  return data;
};

export const getAccount = () => {
  return axios
    .get(endPoint("/account"))
    .then(extract)
    .catch((e) => console.log(e));
};

export const login = (login, password, otp = "") => {
  return axios
    .post(endPoint("/login"), { login, password, otp })
    .then(extract)
    .then(parseResult);
};

export const fetch2faChannels = () => {
  return axios.get(endPoint("/kyc_program/2fa-channels")).then(extract);
};

export const fetchRiskCategories = () => {
  return axios.get(endPoint("/company/risk-categories")).then(extract);
};

export const fetchWalletTypes = () => {
  return axios.get(endPoint("/wallet/types")).then(extract);
};

export const fetchCountries = () => {
  return axios.get(endPoint("/countries")).then(extract);
};

export const fetchCountriesWithUser = () => {
  return axios.get(endPoint("/countries-with-user")).then(extract);
};

export const saveCustomer = async (data) => {
  return axios
    .post(endPoint("/users/save-customer"), data)
    .then(extract)
}

export const assignMainWalletToKycProgram = async (data) => {
  return axios
    .post(endPoint("/users/assign-main-user"), data)
    .then(extract)
}

export const signUp = ({
  email,
  first_name,
  last_name,
  user_phone,
  wallet_type_id,
  kyc_program_id,
  company_risk_category_id,
  name,
  company_email,
  company_number,
  phone,
  website,
  first_name_director,
  last_name_director,
  country,
  city,
  street,
  postal_code,
  description,
}) => {
  return axios
    .post(endPoint("/users/create"), {
      email,
      first_name,
      last_name,
      user_phone,
      wallet_type_id,
      kyc_program_id,
      company_risk_category_id,
      name,
      company_email,
      company_number,
      phone,
      website,
      first_name_director,
      last_name_director,
      country,
      city,
      street,
      postal_code,
      description,
    })
    .then(extract)
    .then(parseResult);
};

export const signUpAdmin = ({
  email,
  password,
  first_name,
  last_name,
  role,
  time_zone_id,
  position = null,
  related_user_ids = null,
  parentEmail = null,
}) => {
  return axios
    .post(endPoint("/admins/create"), {
      email,
      password,
      first_name,
      last_name,
      role,
      time_zone_id,
      position,
      related_user_ids,
      parentEmail,
    })
    .then(extract)
    .then(parseResult);
};

export const assignCustomerToAdmin = ({ adminLogin, parentId }) => {
  return axios
    .post(endPoint("/users/assign-customer-to-admin"), {
      adminLogin,
      parentId,
    })
    .then(extract)
    .then(parseResult);
};

export const assignUserToCompany = ({ login, position, ild_role, parent_id }) => {
  return axios
    .post(endPoint("/users/assign-user-to-company"), {
      login,
      position,
      ild_role,
      parent_id,
    })
    .then(extract)
    .then(parseResult);
};

export const checkUserForAssign = (login) => {
  return axios
    .get(endPoint(`/users/check-user-for-assign/${encodeURIComponent(login)}`))
    .then(extract)
    .then(parseResult);
};

export const createFireblocksVault = (clientId) => {
  return axios
    .post(endPoint("/users/create-vault"), { clientId })
    .then(extract)
    .then(parseResult);
};

export const resetBanFinishTime = (clientId) => {
  return axios
    .post(endPoint("/users/reset-ban-finish-time"), { clientId })
    .then(extract)
    .then(parseResult);
};

export const changeRiskCategory = (clientId, riskCategory) => {
  return axios
    .post(endPoint("/users/change-risk-category"), { clientId, riskCategory })
    .then(extract)
    .then(parseResult);
};

export const updateAssignment = ({ id, position, ild_role }) =>
  axios
    .put(endPoint(`/users/update-assignment/${id}`), { ...(position && { position }), ...(ild_role && { ild_role }) })
    .then(extract)
    .then(parseResult);

export const deleteAssignment = (id) =>
  axios
    .delete(endPoint(`/users/delete-assignment/${id}`))
    .then(extract)
    .then(parseResult);

export const fixFbBalanceForClient = (clientId) => {
  return axios
    .patch(endPoint(`/users/fix-fb-balance/${encodeURIComponent(clientId)}`))
    .then(extract)
    .then(parseResult);
};

export const requestPassRecovery = ({ email }) => {
  return axios
    .post(endPoint("/request/passrecovery"), { email })
    .then(extract)
    .then(parseResult);
};

export const requestPassRecoveryAdmin = ({ email }) => {
  return axios
    .post(endPoint("/request/passrecovery-admin"), { email })
    .then(extract)
    .then(parseResult);
};

export const sendSumSubLink = ({ email }) => {
  return axios
    .post(endPoint("/request/send-sum-sub-link"), { email })
    .then(extract)
    .then(parseResult);
};

export const sendEmailConfirmLink = ({ email }) => {
  return axios
    .post(endPoint("/request/send-email-confirm-link"), { email })
    .then(extract)
    .then(parseResult);
};

export const setPassword = ({ token, password }) => {
  return axios
    .post(endPoint("/recover_password"), { password, token })
    .then(extract)
    .then(parseResult);
};

export const fetchSite = () => {
  return axios
    .get(endPoint("/admin/fetch-site"))
    .then(extract)
    .then(parseResult);
};

export const fetchBalances = () => {
  return axios
    .get(endPoint("/finance/balances"))
    .then(extract)
    .then(parseResult);
};

export const getLastAddress = (asset) => {
  return axios.get(endPoint(`/finance/address/${asset}`)).then(extract);
};

export const getNewAddress = (asset) => {
  return axios.post(endPoint(`/finance/address/${asset}`)).then(extract);
};

export const fetchTransactions = (asset, count = 100, offset = 0) => {
  return axios
    .get(endPoint(`/finance/transactions/${asset}`, { count, offset }))
    .then(extract);
};

export const fetchFeeTxs = (asset, count = 100, offset = 0) => {
  return axios
    .get(endPoint(`/fee_transactions/${asset}`, { count, offset }))
    .then(extract);
};

export const fetchAdminBalances = () => {
  return axios.get(endPoint("/admin/balances")).then(extract);
};

export const adminSendFee = ({
  asset,
  rate,
  amount,
  address,
  otp,
  subtract = false,
}) => {
  return axios
    .post(endPoint("/admin/withdraw_fees"), {
      asset,
      amount,
      address,
      rate,
      otp,
      subtract,
    })
    .then(extract)
    .then(parseResult);
};

export const logout = () => {
  return axios.post(endPoint("/logout")).then(extract);
};

export const updateClientFromAdmin = (toUpdate) => {
  let data = {};
  if (toUpdate.hasOwnProperty("login") && toUpdate.login) {
    data.login = toUpdate.login;
  }
  if (toUpdate.hasOwnProperty("first_name") && toUpdate.first_name) {
    data.first_name = toUpdate.first_name;
  }
  if (toUpdate.hasOwnProperty("last_name") && toUpdate.last_name) {
    data.last_name = toUpdate.last_name;
  }
  if (toUpdate.hasOwnProperty("is_active")) {
    data.is_active = toUpdate.is_active;
  }
  if (Object.keys(data).length === 0) {
    return Promise.resolve({});
  }
  return axios
    .post(endPoint("/user/update"), data)
    .then(extract)
    .then(parseResult);
};

export const updateUser = (toUpdate) => {
  let data = {};
  if (toUpdate.hasOwnProperty("first_name") && toUpdate.first_name) {
    data.first_name = toUpdate.first_name;
  }
  if (toUpdate.hasOwnProperty("last_name") && toUpdate.last_name) {
    data.last_name = toUpdate.last_name;
  }
  if (toUpdate.hasOwnProperty("phone") && toUpdate.phone) {
    data.phone = toUpdate.phone;
  }
  if (toUpdate.hasOwnProperty("is_active")) {
    data.is_active = toUpdate.is_active;
  }
  if (toUpdate.hasOwnProperty("otp_enabled")) {
    data.otp_enabled = toUpdate.otp_enabled;
  }
  if (toUpdate.hasOwnProperty("otp")) {
    data.otp = toUpdate.otp;
  }
  if (toUpdate.hasOwnProperty("avatar")) {
    data.avatar = toUpdate.avatar;
  }
  if (toUpdate.hasOwnProperty("id_doc")) {
    data.id_doc = toUpdate.id_doc;
  }
  if (toUpdate.hasOwnProperty("address_doc")) {
    data.address_doc = toUpdate.address_doc;
  }

  if (Object.keys(data).length === 0) {
    return Promise.resolve({});
  }

  return axios.post(endPoint("/account"), data).then(extract).then(parseResult);
};

export const updatePassword = ({ password, old_password }) => {
  return axios
    .post(endPoint("/account/password"), { password, old_password })
    .then(extract)
    .then(parseResult);
};

export const refreshSession = ({ password }) => {
  return axios
    .post(endPoint("/account/re-authenticate"), { password })
    .then(extract)
    .then(parseResult);
};

// Admin
export const fetchSettings = () =>
  axios.get(endPoint("/settings")).then(extract).then(parseResult);

export const saveSetting = (values) =>
  axios.post(endPoint("/settings"), { values }).then(extract).then(parseResult);

export const fetchKycRequests = (
  count,
  offset,
  sort,
  direction,
  searchField = null,
  searchValue = null
) => {
  return axios
    .get(
      endPoint("/kyc_program/request/list", {
        count,
        offset,
        sort,
        direction,
        searchField,
        searchValue,
      })
    )
    .then(extract);
};

export const uploadKycFile = async ({
  name,
  file_type,
  user_login,
  base64,
  assign_id,
  document_id,
  trans_id
}) => {
  const payload = {
    name,
    file_type,
    user_login,
    base64,
    assign_id,
    document_id,
    trans_id,
  };

  const r = await axios.post(endPoint("/upload-file"), payload);
  const data = await extract(r);
  return parseResult(data);
};

export const uploadComplianceNote = async ({
  name,
  file_type,
  base64,
  trans_id
}) => {
  const payload = {
    name,
    file_type,
    base64,
    trans_id,
  };

  const r = await axios.post(endPoint("/upload-file-compliance-note"), payload);
  const data = await extract(r);
  return parseResult(data);
};

export const getComplianceNoteDocs = async (trans_id) => {
  const payload = { trans_id };

  const r = await axios.post(endPoint("/get-compliance-files"), payload);
  const data = await extract(r);
  return parseResult(data);
};


export const uploadKycFileOld = ({
  name,
  file,
  user_login,
  assignId,
  documentId,
}) => {
  let formData = new FormData();
  formData.append(name, file);
  formData.append("user_login", user_login);
  formData.append("assign_id", assignId);
  formData.append("document_id", documentId);
  /*
    for (let [key, value] of formData.entries()) {
        console.log(key, value);
    }
     */
  return axios
    .post(endPoint("/upload"), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(extract)
    .then(parseResult)
    .then((res) => res.files[name]);
};

export const updateKycRequest = (id, payload) => {
  return axios
    .put(endPoint(`/kyc_program/request/update/${id}`), {
      ...payload,
    })
    .then(extract);
};

export const updateKycRequestForVerification = (id, payload) => {
  return axios
    .put(endPoint(`/kyc_program/request/update-new/${id}`), {
      ...payload,
    })
    .then(extract);
};

export const deleteKycRequest = (id) => {
  return axios
    .delete(endPoint(`/kyc_program/request/delete/${id}`))
    .then(extract);
};

export const fetchKycDocumentsForVerification = (
  clientId
) => {
  return axios
    .get(
      endPoint("/kyc_document/list-for-verification", {
        clientId
      })
    )
    .then(extract);
};



export const fetchKycDocuments = (
  count,
  offset,
  sort,
  direction,
  name = null,
) => {
  return axios
    .get(
      endPoint("/kyc_document/list", {
        count,
        offset,
        sort,
        direction,
        name,
      })
    )
    .then(extract);
};

export const getKycDocumentTypes = () => {
  return axios
    .get(endPoint("/kyc_document/types"))
    .then(extract)
    .then(parseResult);
};

export const createKycDocument = ({
  name,
  doc_type_id,
  doc_value,
  description,
  doc_expire_in_days,
  document_order,
  display_name,
}) => {
  return axios
    .post(endPoint("/kyc_document/create"), {
      name,
      doc_type_id,
      doc_value,
      description,
      doc_expire_in_days,
      document_order,
      display_name,
    })
    .then(extract);
};

export const updateKycDocument = (
  id,
  {
    name,
    doc_type_id,
    doc_value,
    description,
    doc_expire_in_days,
    document_order,
    display_name,
  }
) => {
  return axios
    .put(endPoint(`/kyc_document/update/${id}`), {
      name,
      doc_type_id,
      doc_value,
      description,
      doc_expire_in_days,
      document_order,
      display_name,
    })
    .then(extract);
};

export const deleteKycDocument = (id) => {
  return axios.delete(endPoint(`/kyc_document/delete/${id}`)).then(extract);
};

export const getIdDocument = ({ url }) => {
  return axios
    .post(endPoint("/kyc_document/getid"), {
      url,
    })
    .then(extract);
};

export const getFlow = () => {
  return axios.get(endPoint("/kyc_program/flow")).then(extract);
};

export const updateWalletStatus = (id, { status }) => {
  return axios
    .put(endPoint(`/kyc_program/request/status/${id}`), {
      kyc_program_status: status,
    })
    .then(extract);
};

export const getAllKycDocuments = () => {
  const queryParams = {
    count: 10000,
    offset: 0,
    sort: "id",
    direction: "ASC"
  };

  return axios
    .get(endPoint("/kyc_document/list"), { params: queryParams })
    .then(extract);
};

export const getRequestDocuments = (program_id, wallet_id, trans_id) => {
  const params = new URLSearchParams({});
  if (program_id) params.append("program_id", program_id);
  if (wallet_id) params.append("wallet_id", wallet_id);
  if (trans_id) params.append("trans_id", trans_id);
  return axios
    .get(
      endPoint(
        `/kyc_program/request/documents/list${params.toString() ? `?${params.toString()}` : ""
        }`
      )
    )
    .then(extract);
};

export const updateRequestDocuments = (id, { expirationDate }) => {
  return axios
    .put(endPoint(`/kyc_program/request/documents/${id}`), {
      expiration_date: expirationDate,
    })
    .then(extract);
};

export const resendFampayNotification = ({ num }) => {
  return axios
    .post(endPoint(`/transactions/prepare-fampay-payload-for-resend/${num}`), {
    })
    .then(extract);
};

export const updateTransactionStatus = ({ transId, ...rest }) => {
  return axios
    .put(endPoint(`/kyc_program/request/status/transaction/${transId}`), {
      ...rest,
    })
    .then(extract);
};


export const confirmTransactionManually = ({ num, hash, amount }) => {
  return axios
    .post(endPoint(`/transactions/set_hash/${num}`), {
      hash,
      amount,
    })
    .then(extract);
};

export const updateSingleTransaction = async (num, forUpdate) => {
  const response = await axios.put(endPoint(`/transactions/update/${num}`), forUpdate);
  return extract(response);
};


export const setTransactionStatusToPaid = ({ num, bankTransactionId, gatewaySolution, providerName }) => {
  return axios
    .post(endPoint(`/transactions/set_status_to_paid/${num}`), {
      bankTransactionId, gatewaySolution, providerName
    })
    .then(extract);
};


export const setTransactionStatusToDeclined = ({ num, }) => {
  return axios
    .post(endPoint(`/transactions/set_status_to_declined/${num}`), {

    })
    .then(extract);
};

export const setTransactionStatusToPendingPayment = ({ num, }) => {
  return axios
    .post(endPoint(`/transactions/set_status_to_pending_payment/${num}`), {

    })
    .then(extract);
};

export const setTransactionStatusToPendingTransfer = ({ num, }) => {
  return axios
    .post(endPoint(`/transactions/set_status_to_pending_transfer/${num}`), {

    })
    .then(extract);
};

export const setTransactionStatusToRefunded = ({ num, }) => {
  return axios
    .post(endPoint(`/transactions/set_status_to_refunded/${num}`), {

    })
    .then(extract);
};

export const setTransactionStatusToChargeBack = ({ num, }) => {
  return axios
    .post(endPoint(`/transactions/set_status_to_charge_back/${num}`), {

    })
    .then(extract);
};

export const sendEmailForManualTransaction = ({ num }) => {
  return axios
    .post(endPoint(`/transactions/send_email_for_manual_transaction/${num}`), {})
    .then(extract);
};


export const updateCompanyStatus = ({ transId, ...rest }) => {
  return axios
    .put(endPoint(`/kyc_program/request/status/transaction/${transId}`), {
      ...rest,
    })
    .then(extract);
};

export const updateUserBlocking = (id) => {
  return axios
    .patch(endPoint(`/users/block-except-forms/${id}`))
    .then(extract)
    .then(parseResult);
};

export const updateCustomerForm = (idp, formKey, formData) => {
  return axios
    .put(
      endPoint(`/users/update-form/${idp}`),
      { formKey, formData }
    )
    .then(extract)
    .then(parseResult);
};

export const getAssignedKycDocuments = (id) => {
  return axios.get(endPoint(`/kyc_program/assign/${id}`)).then(extract);
};

export const assignProgramToUser = ({ program_id, login }) => {
  return axios
    .post(endPoint("/kyc_program/user/program"), {
      login,
      program_id,
    })
    .then(extract);
};

export const getAssignedProgramsAdmin = (login) => {
  return axios
    .get(endPoint(`/kyc_program/assign/program/admin/${login}`))
    .then(extract);
};

export const assignProgramsToAdmin = ({ program_ids, login }) => {
  return axios
    .post(endPoint("/kyc_program/assign/programs/admin/create"), {
      login,
      program_ids,
    })
    .then(extract);
};

export const assignProgramToAdmin = ({ program_id, login }) => {
  return axios
    .post(endPoint("/kyc_program/assign/program/admin/create"), {
      login,
      program_id,
    })
    .then(extract);
};

export const unAssignProgramToAdmin = ({ program_id, login }) => {
  return axios
    .delete(endPoint("/kyc_program/assign/program/admin/delete"), {
      data: {
        login,
        program_id,
      },
    })
    .then(extract);
};

export const assignDocumentToProgram = ({ document_id, program_id }) => {
  return axios
    .post(endPoint("/kyc_program/assign/create"), {
      document_id,
      program_id,
    })
    .then(extract);
};


export const deleteDestinationAddress = ({ destination_address_id }) => {
  return axios
    .delete(endPoint(`/kyc_program/destination_address/delete/${destination_address_id}`))
    .then(extract);
};

export const createDestinationAddress = ({ blockchain, address, kyc_program_id, crypto }) => {
  return axios
    .post(endPoint(`/kyc_program/destination_address/create`), {
      blockchain, address, kyc_program_id, crypto
    })
    .then(extract);
};

export const toggleActiveDestinationAddress = ({ id }) => {
  return axios
    .put(endPoint(`/kyc_program/destination_address/toggle-active/${id}`))
    .then(extract);
};

export const updateDestinationAddress = ({ id, address }) => {
  return axios
    .put(
      endPoint(
        `/kyc_program/destination_address/update/${id}/${encodeURIComponent(
          address
        )}`
      )
    )
    .then(extract);
};

export const deleteAssignedClientId = ({ id }) => {
  return axios
    .put(endPoint(`/kyc_program/assigned-client/delete/${id}`))
    .then(extract);
};

export const unAssignDocumentToProgram = ({ document_id, program_id }) => {
  return axios
    .delete(endPoint("/kyc_program/assign/delete"), {
      data: {
        document_id,
        program_id,
      },
    })
    .then(extract);
};

export const createKycProgram = (data) => {
  const {
    // file dropped by request
    name,
    siteHost: site_host,
    storeId: store_id,
    walletType: wallet_type,
    description,

    // document rules
    requireDocumentsForIncomingTransactions: require_documents_for_trans,
    requireDocumentsForOutgoingTransactions: require_documents_for_outgoing_transactions,
    requireDocumentsForBuyTransactions: require_documents_for_buy_transactions,
    requireDocumentsForSellTransactions: require_documents_for_sell_transactions,

    // chain & SumSub rules
    forceScoreChainForIncoming: force_score_chain_for_incoming,
    forceScoreChainForOutgoing: force_score_chain_for_outgoing,
    forceSumSubForIncomings: force_sum_sub_for_incoming_transactions,
    forceSumSubForOutgoings: force_sum_sub_for_outgoing_transactions,
    forceSumSubForExchangeBuy: force_sum_sub_for_exchange_buy,
    forceSumSubForExchangeSell: force_sum_sub_for_exchange_sell,

    // platforms
    defaultPlatformBuyId: default_platform_buy_id,
    defaultPlatformSellId: default_platform_sell_id,

    // 2FA & notifications
    twofaChannelId: twofa_channel_id,
    operatorNotificationEmail: operator_notification_email,
    qrCodeNotificationLink: qr_code_notification_link,
    defaultMobileCountryCode: default_mobile_country_code,
    qrCodeAssets: qr_code_assets,

    // currency & cryptos
    defaultCurrency: default_currency,
    supportedCryptos: supported_cryptos,
    swapEnabled: swap_enabled,
    allowOverrideDefaultCurrency: allow_override_default_currency,

    // features
    buyFeatureEnabled: buy_feature_enabled,
    sellFeatureEnabled: sell_feature_enabled,
    sendFeatureEnabled: send_feature_enabled,
    receiveFeatureEnabled: receive_feature_enabled,
    manualTx: manual_tx,
    allowSendPreFilledDocumentDuringBuySell: allow_send_pre_filled_document_during_buy_sell,
    showSecurityBox: show_security_box,
    useHelloSignForDod: use_hello_sign_for_dod,
    hideBusinessWallet: hide_business_wallet,
    disableTwoFa: disable_2fa,
    hideTransactionTypeColumn: hide_transaction_type_column,
    allowSendBatchTransactions: allow_send_batch_transactions,
    mobileVerificationWhenRegistration: mobile_verification_when_registration,
    autoVerificationAfterRegistration: auto_verification_after_registration,
    enableTopUpWebhook: enable_top_up_webhook,
    enableSumSubKycVerification: enable_sum_sub_kyc_verification,
    disableAllNotifications: disable_all_notifications,
    sumSubVerificationLevel: sum_sub_verification_level,
    allowSetPasswordDuringRegistration: allow_set_password_during_registration,
    registrationType: registration_type,
    questionnaireFormEnabled: questionnaire_form_enabled,
    disableAddressFieldsInRegistrationForm: disable_address_fields_in_registration_form,
    allowEditTransactionByAdmin: allow_edit_transaction_by_admin,

    // terminal & fees
    terminalKey: terminal_key,
    exchangeFeePercent: exchange_fee_percent,
    exchangeSellFeePercent: exchange_sell_fee_percent,

    // misc
    maxAgeInRegistration: max_age_in_registration,
    emailVerificationWhenRegistration: email_verification_when_registration,
    enableFireBlocksWallet: enable_fire_block_wallet,
    preventCustomerLogin: prevent_customer_login,
    enableBlockFillsTrading: enable_block_fills_trading,
    enableQuestionnaireIndividualLvl1: enable_questionnaire_individual_lvl1,
    enableQuestionnaireCorporateLvl1: enable_questionnaire_corporate_lvl1,
    enableQuestionnaireIndividualLvl2: enable_questionnaire_individual_lvl2,
    enableQuestionnaireCorporateEdd: enable_questionnaire_corporate_edd,
    enableAdminToEditCustomerEmail: enable_admin_to_edit_customer_email,
    enableMainWallet: enable_main_wallet,
    mainWalletAccountEmail: main_wallet_account_email,
    sendFundToDestinationBtc: send_fund_to_destination_btc,
    sendFundToDestinationTrc20: send_fund_to_destination_trc20,
    sendFundToDestinationErc20: send_fund_to_destination_erc20,
    allowTronFreezeBalance: allow_tron_freeze_balance,
    allowDelegateTronEnergy: allow_delegate_tron_energy,
    sendFundsToDestinationMinimum: send_funds_to_destination_minimum,
    qrCodeTransactionsReview: qr_code_transactions_review,
    registrationAllowOnlyLatin: registration_allow_only_latin,
    kycModalAlternative: kyc_modal_alternative,
    autoApproveAfterKyc: auto_approve_after_kyc,
    enableEditQuestionnaire: enable_edit_questionnaire,
    allowResendNotificationForTrx: allow_resend_notification_for_trx,
    allowResendHelloSignTcoForTrx: allow_resend_hello_sign_tco_for_trx,
    btcSingleHashBatchTransferFeeInEur: btc_single_hash_batch_transfer_fee_in_eur,
    btcMultipleHashBatchTransferFeeInEur: btc_multiple_hash_batch_transfer_fee_in_eur,
    erc20TransferFeeInEur: erc20_transfer_fee_in_eur,
    trc20TransferFeeInEur: trc20_transfer_fee_in_eur,
    sumSubAddressWhitelisting: sum_sub_address_whitelisting,
    processTrxsFromAnotherVasp: process_trxs_from_another_vasp,
    enableQrCode: enable_qr_code,
    banFeatureEnabled: ban_feature_enabled,
    networkFeeProviderEthAddress: fee_provider_eth_address,
    networkFeeProviderTrxAddress: fee_provider_trx_address,
    companyFeeReceiverBtcAddress: company_fee_receiver_btc_address,
    companyFeeReceiverEthAddress: company_fee_receiver_eth_address,
    companyFeeReceiverTrxAddress: company_fee_receiver_trx_address,

  } = data;

  // backend expects supported_cryptos as a comma-separated string
  const supported_cryptos_str = Array.isArray(supported_cryptos)
    ? supported_cryptos.join(',')
    : supported_cryptos;

  const payload = {
    fee_provider_eth_address,
    fee_provider_trx_address,
    company_fee_receiver_btc_address,
    company_fee_receiver_eth_address,
    company_fee_receiver_trx_address,
    registration_allow_only_latin,
    kyc_modal_alternative,
    auto_approve_after_kyc,
    enable_edit_questionnaire,
    sum_sub_address_whitelisting,
    allow_resend_notification_for_trx,
    allow_resend_hello_sign_tco_for_trx,
    btc_single_hash_batch_transfer_fee_in_eur,
    btc_multiple_hash_batch_transfer_fee_in_eur,
    erc20_transfer_fee_in_eur,
    trc20_transfer_fee_in_eur,
    process_trxs_from_another_vasp,
    enable_qr_code,
    ban_feature_enabled,
    send_fund_to_destination_btc,
    send_fund_to_destination_trc20,
    send_fund_to_destination_erc20,
    allow_tron_freeze_balance,
    allow_delegate_tron_energy,
    send_funds_to_destination_minimum,
    qr_code_transactions_review,
    enable_main_wallet,
    main_wallet_account_email,

    email_verification_when_registration,
    enable_admin_to_edit_customer_email,
    enable_fire_block_wallet,
    enable_block_fills_trading,
    prevent_customer_login,

    enable_questionnaire_individual_lvl1,
    enable_questionnaire_corporate_lvl1,
    enable_questionnaire_individual_lvl2,
    enable_questionnaire_corporate_edd,

    name,
    wallet_type,
    description,

    require_documents_for_outgoing_transactions,
    allow_send_pre_filled_document_during_buy_sell,
    show_security_box,
    require_documents_for_buy_transactions,
    require_documents_for_sell_transactions,
    require_documents_for_trans,

    force_score_chain_for_incoming,
    force_score_chain_for_outgoing,
    force_sum_sub_for_incoming_transactions,
    force_sum_sub_for_outgoing_transactions,
    force_sum_sub_for_exchange_buy,
    force_sum_sub_for_exchange_sell,

    default_platform_buy_id,
    default_platform_sell_id,

    site_host,
    store_id,

    twofa_channel_id,

    default_currency,
    supported_cryptos: supported_cryptos_str,
    swap_enabled,
    allow_override_default_currency,

    buy_feature_enabled,
    sell_feature_enabled,
    send_feature_enabled,
    receive_feature_enabled,
    manual_tx,
    use_hello_sign_for_dod,
    hide_business_wallet,
    disable_2fa,
    hide_transaction_type_column,
    allow_send_batch_transactions,
    mobile_verification_when_registration,
    auto_verification_after_registration,
    enable_top_up_webhook,
    enable_sum_sub_kyc_verification,
    disable_all_notifications,
    sum_sub_verification_level,

    allow_set_password_during_registration,
    registration_type,
    questionnaire_form_enabled,
    disable_address_fields_in_registration_form,

    terminal_key,
    exchange_fee_percent,
    exchange_sell_fee_percent,

    allow_edit_transaction_by_admin,
    max_age_in_registration,
    qr_code_notification_link,
    default_mobile_country_code,
    qr_code_assets
  };

  // only include if provided
  if (operator_notification_email) {
    payload.operator_notification_email = operator_notification_email;
  }

  return axios
    .post(endPoint("/kyc_program/create"), payload, {
      headers: { "Content-Type": "application/json" },
    })
    .then(extract);
};

export const updateKycProgram = (id, data) => {
  const {
    // top‐level toggles
    networkFeeProviderEthAddress: fee_provider_eth_address,
    networkFeeProviderTrxAddress: fee_provider_trx_address,
    companyFeeReceiverBtcAddress: company_fee_receiver_btc_address,
    companyFeeReceiverEthAddress: company_fee_receiver_eth_address,
    companyFeeReceiverTrxAddress: company_fee_receiver_trx_address,
    registrationAllowOnlyLatin: registration_allow_only_latin,
    kycModalAlternative: kyc_modal_alternative,
    autoApproveAfterKyc: auto_approve_after_kyc,
    enableEditQuestionnaire: enable_edit_questionnaire,
    sumSubAddressWhitelisting: sum_sub_address_whitelisting,
    allowResendNotificationForTrx: allow_resend_notification_for_trx,
    allowResendHelloSignTcoForTrx: allow_resend_hello_sign_tco_for_trx,
    btcSingleHashBatchTransferFeeInEur: btc_single_hash_batch_transfer_fee_in_eur,
    btcMultipleHashBatchTransferFeeInEur: btc_multiple_hash_batch_transfer_fee_in_eur,
    erc20TransferFeeInEur: erc20_transfer_fee_in_eur,
    trc20TransferFeeInEur: trc20_transfer_fee_in_eur,
    processTrxsFromAnotherVasp: process_trxs_from_another_vasp,
    enableQrCode: enable_qr_code,
    banFeatureEnabled: ban_feature_enabled,
    sendFundToDestinationBtc: send_fund_to_destination_btc,
    sendFundToDestinationTrc20: send_fund_to_destination_trc20,
    sendFundToDestinationErc20: send_fund_to_destination_erc20,
    allowTronFreezeBalance: allow_tron_freeze_balance,
    allowDelegateTronEnergy: allow_delegate_tron_energy,
    sendFundsToDestinationMinimum: send_funds_to_destination_minimum,
    qrCodeTransactionsReview: qr_code_transactions_review,
    enableMainWallet: enable_main_wallet,
    mainWalletAccountEmail: main_wallet_account_email,
    emailVerificationWhenRegistration: email_verification_when_registration,
    enableAdminToEditCustomerEmail: enable_admin_to_edit_customer_email,
    enableFireBlocksWallet: enable_fire_block_wallet,
    enableBlockFillsTrading: enable_block_fills_trading,
    preventCustomerLogin: prevent_customer_login,
    enableQuestionnaireIndividualLvl1: enable_questionnaire_individual_lvl1,
    enableQuestionnaireCorporateLvl1: enable_questionnaire_corporate_lvl1,
    enableQuestionnaireIndividualLvl2: enable_questionnaire_individual_lvl2,
    enableQuestionnaireCorporateEdd: enable_questionnaire_corporate_edd,

    // core fields
    name,
    walletType: wallet_type,
    description,
    allowSendPreFilledDocumentDuringBuySell: allow_send_pre_filled_document_during_buy_sell,
    showSecurityBox: show_security_box,

    // document requirements
    requireDocumentsForBuyTransactions: require_documents_for_buy_transactions,
    requireDocumentsForSellTransactions: require_documents_for_sell_transactions,
    requireDocumentsForOutgoingTransactions: require_documents_for_outgoing_transactions,
    requireDocumentsForIncomingTransactions: require_documents_for_trans,

    // age limit
    maxAgeInRegistration: max_age_in_registration,

    // chains & platforms
    forceScoreChainForIncoming: force_score_chain_for_incoming,
    forceScoreChainForOutgoing: force_score_chain_for_outgoing,
    forceSumSubForIncomings: force_sum_sub_for_incoming_transactions,
    forceSumSubForOutgoings: force_sum_sub_for_outgoing_transactions,
    forceSumSubForExchangeBuy: force_sum_sub_for_exchange_buy,
    forceSumSubForExchangeSell: force_sum_sub_for_exchange_sell,
    defaultPlatformBuyId: default_platform_buy_id,
    defaultPlatformSellId: default_platform_sell_id,

    // two-factor & notifications
    twofaChannelId: twofa_channel_id,
    operatorNotificationEmail: operator_notification_email,
    qrCodeNotificationLink: qr_code_notification_link,
    defaultMobileCountryCode: default_mobile_country_code,
    qrCodeAssets: qr_code_assets,

    // currency & cryptos
    defaultCurrency: default_currency,
    supportedCryptos: supported_cryptos,
    swapEnabled: swap_enabled,
    allowOverrideDefaultCurrency: allow_override_default_currency,

    // feature toggles
    buyFeatureEnabled: buy_feature_enabled,
    sellFeatureEnabled: sell_feature_enabled,
    sendFeatureEnabled: send_feature_enabled,
    receiveFeatureEnabled: receive_feature_enabled,
    manualTx: manual_tx,
    useHelloSignForDod: use_hello_sign_for_dod,
    hideBusinessWallet: hide_business_wallet,
    disableTwoFa: disable_2fa,
    hideTransactionTypeColumn: hide_transaction_type_column,
    allowSendBatchTransactions: allow_send_batch_transactions,
    mobileVerificationWhenRegistration: mobile_verification_when_registration,
    autoVerificationAfterRegistration: auto_verification_after_registration,
    enableTopUpWebhook: enable_top_up_webhook,
    enableSumSubKycVerification: enable_sum_sub_kyc_verification,
    disableAllNotifications: disable_all_notifications,
    sumSubVerificationLevel: sum_sub_verification_level,

    // registration settings
    allowSetPasswordDuringRegistration: allow_set_password_during_registration,
    registrationType: registration_type,
    questionnaireFormEnabled: questionnaire_form_enabled,
    disableAddressFieldsInRegistrationForm: disable_address_fields_in_registration_form,

    // admin/edit
    allowEditTransactionByAdmin: allow_edit_transaction_by_admin,

    // terminal/settings
    terminalKey: terminal_key,
    exchangeFeePercent: exchange_fee_percent,
    exchangeSellFeePercent: exchange_sell_fee_percent,

    // routing
    siteHost: site_host,
    storeId: store_id,
  } = data;

  const supported_cryptos_str = Array.isArray(supported_cryptos)
    ? supported_cryptos.join(',')
    : supported_cryptos;

  const payload = {
    fee_provider_eth_address,
    qr_code_notification_link,
    default_mobile_country_code,
    qr_code_assets,
    fee_provider_trx_address,
    company_fee_receiver_btc_address,
    company_fee_receiver_eth_address,
    company_fee_receiver_trx_address,
    send_fund_to_destination_btc,
    send_fund_to_destination_trc20,
    send_fund_to_destination_erc20,
    allow_tron_freeze_balance,
    allow_delegate_tron_energy,
    registration_allow_only_latin,
    kyc_modal_alternative,
    auto_approve_after_kyc,
    enable_edit_questionnaire,
    sum_sub_address_whitelisting,
    allow_resend_notification_for_trx,
    allow_resend_hello_sign_tco_for_trx,
    btc_single_hash_batch_transfer_fee_in_eur,
    btc_multiple_hash_batch_transfer_fee_in_eur,
    erc20_transfer_fee_in_eur,
    trc20_transfer_fee_in_eur,
    process_trxs_from_another_vasp,
    enable_qr_code,
    ban_feature_enabled,
    send_funds_to_destination_minimum,
    qr_code_transactions_review,
    enable_main_wallet,
    main_wallet_account_email,
    email_verification_when_registration,
    enable_admin_to_edit_customer_email,
    enable_fire_block_wallet,
    enable_block_fills_trading,
    prevent_customer_login,
    enable_questionnaire_individual_lvl1,
    enable_questionnaire_corporate_lvl1,
    enable_questionnaire_individual_lvl2,
    enable_questionnaire_corporate_edd,

    name,
    wallet_type,
    description,
    allow_send_pre_filled_document_during_buy_sell,
    show_security_box,

    require_documents_for_buy_transactions,
    max_age_in_registration,
    require_documents_for_sell_transactions,
    require_documents_for_outgoing_transactions,
    require_documents_for_trans,

    force_score_chain_for_incoming,
    force_score_chain_for_outgoing,
    force_sum_sub_for_incoming_transactions,
    force_sum_sub_for_outgoing_transactions,
    force_sum_sub_for_exchange_buy,
    force_sum_sub_for_exchange_sell,
    default_platform_buy_id,
    default_platform_sell_id,

    twofa_channel_id,

    default_currency,
    supported_cryptos: supported_cryptos_str,
    swap_enabled,
    allow_override_default_currency,

    buy_feature_enabled,
    sell_feature_enabled,
    send_feature_enabled,
    receive_feature_enabled,
    manual_tx,
    use_hello_sign_for_dod,
    hide_business_wallet,
    disable_2fa,
    hide_transaction_type_column,
    allow_send_batch_transactions,
    mobile_verification_when_registration,
    auto_verification_after_registration,
    enable_top_up_webhook,
    enable_sum_sub_kyc_verification,
    disable_all_notifications,
    sum_sub_verification_level,

    allow_set_password_during_registration,
    registration_type,
    questionnaire_form_enabled,
    disable_address_fields_in_registration_form,

    allow_edit_transaction_by_admin,

    terminal_key,
    exchange_fee_percent,
    exchange_sell_fee_percent,

    site_host,
    store_id,
  };

  // only include this if it was provided
  if (operator_notification_email) {
    payload.operator_notification_email = operator_notification_email;
  }

  return axios
    .put(endPoint(`/kyc_program/update/${id}`), payload, {
      headers: { "Content-Type": "application/json" },
    })
    .then(extract);
};

export const updateKycProgramAddresses = (id, data) => {
  const {
    fireBlocksCompanyBtcAddress: fire_blocks_compnay_btc_address,
    fireBlocksCompanyEthAddress: fire_blocks_compnay_eth_address,
    fireBlocksCompanyTrxAddress: fire_blocks_compnay_trx_address,
    blockFillsCompanyBtcAddress: blockfills_company_btc_address,
    blockFillsCompanyEthAddress: blockfills_company_eth_address,
    blockFillsCompanyTrxAddress: blockfills_company_trx_address,
    krakenCompanyBtcAddress: kraken_company_btc_address,
    krakenCompanyEthAddress: kraken_company_eth_address,
    krakenCompanyTrxAddress: kraken_company_trx_address,
  } = data;

  const formData = new FormData();

  formData.append(
    "fire_blocks_compnay_btc_address",
    fire_blocks_compnay_btc_address
  );
  formData.append(
    "fire_blocks_compnay_eth_address",
    fire_blocks_compnay_eth_address
  );
  formData.append(
    "fire_blocks_compnay_trx_address",
    fire_blocks_compnay_trx_address
  );

  formData.append(
    "blockfills_company_btc_address",
    blockfills_company_btc_address
  );
  formData.append(
    "blockfills_company_eth_address",
    blockfills_company_eth_address
  );
  formData.append(
    "blockfills_company_trx_address",
    blockfills_company_trx_address
  );

  formData.append("kraken_company_btc_address", kraken_company_btc_address);
  formData.append("kraken_company_eth_address", kraken_company_eth_address);
  formData.append("kraken_company_trx_address", kraken_company_trx_address);

  return axios
    .put(endPoint(`/kyc_program/update-address-fields/${id}`), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(extract);
};

export const deleteKycProgram = (id) => {
  return axios.delete(endPoint(`/kyc_program/delete/${id}`)).then(extract);
};

export const getKycProgram = (id) => {
  return axios.get(endPoint(`/kyc_program/show?id=${id}`)).then(extract);
};

export const cloneKycProgram = (id) => {
  return axios.get(endPoint(`/kyc_program/clone?id=${id}`)).then(extract);
};


export const assignBtcAddressToKycProgram = (id) => {
  return axios.get(endPoint(`/kyc_program/assign-btc-address/${id}`)).then(extract);
};

export const getKycProgramFeeSettings = (id) => {
  return axios.get(endPoint(`/kyc_program/fee-settings?id=${id}`)).then(extract);
};

export const saveKycProgramFeeSettings = async ({ asset, kycProgramId, feeValue, feeCalculationType }) => {
  try {
    const response = await axios
      .post(endPoint("/kyc_program/fee-settings"), { asset, kycProgramId, feeValue, feeCalculationType });
    return response.data.feeSettings;
  } catch (error) {
    return [];
  }
};

export const getUserFeeSettingsIledgends = (id) => {
  return axios.get(endPoint(`/users/fee-settings?id=${id}`)).then(extract);
};

export const updateUserFeeSettingsIledgends = (params) => {
  return axios.patch(endPoint(`/users/fee-settings`), params).then(extract);
};

export const updateCustomerStatus = (idp, { status, reasonStatusChange, reviewDate, riskLevel, segment }) => {
  return axios
    .put(endPoint(`/users/update-customer-status/${idp}`), {
      status,
      reasonStatusChange,
      reviewDate,
      riskLevel,
      segment
    })
    .then(extract)
    .then(parseResult);
};

export const fetchKycPrograms = (
  count,
  offset,
  sort,
  direction,
  name = null,
) => {
  return axios
    .get(
      endPoint("/kyc_program/list", {
        count,
        offset,
        sort,
        direction,
        name,
      })
    )
    .then(extract);
};

export const fetchApiUsersData = (
  count,
  offset,
  sort,
  direction,
  kycProgramStatus = -1,
  xlsDownload = false,
  registrationDateFrom = null,
  registrationDateTo = null,
  countryIds = [],
  kycProgramIds = [],
  login = '',
  phone = '',
  clientId = '',
  fullName = '',
  kycProgramName = '',
  verificationStatus = '',
  numberOfSuccessTransactions = '',
  totalBuyInEuro = '',
  id = '',
  pepOrClosed = '',
  statusAll = '',
  riskLevel = '',
) => {
  const content = xlsDownload ? {
    responseType: "blob",
  } : {};
  return axios
    .get(
      endPoint("/users/list", {
        count,
        offset,
        sort,
        direction,
        kycProgramStatus,
        xlsDownload,
        registrationDateFrom,
        registrationDateTo,
        countryIds,
        kycProgramIds,
        login,
        phone,
        clientId,
        fullName,
        kycProgramName,
        verificationStatus,
        numberOfSuccessTransactions,
        totalBuyInEuro,
        id,
        pepOrClosed,
        statusAll,
        riskLevel
      }), {
      ...content
    }
    )
    .then(extract);
};

export const gatValueList = (name) => {
  return axios
    .get(endPoint(`/list/${name}`))
    .then(extract)
    .then(parseResult);
};

export const getCompanyByUserLogin = (login) => {
  return axios
    .get(endPoint(`/company/${login}`))
    .then(extract)
    .then(parseResult);
};

export const updateCompany = (id, toUpdate) => {
  return axios
    .put(endPoint(`/company/update/${id}`), toUpdate)
    .then(extract)
    .then(parseResult);
};

export const fetchApiCompaniesData = (
  count,
  offset,
  sort,
  direction,
  searchField = null,
  searchValue = null
) => {
  return axios
    .get(
      endPoint("/company/list", {
        count,
        offset,
        sort,
        direction,
        searchField,
        searchValue,
      })
    )
    .then(extract);
};

export const getFlowGetId = () => {
  return axios.get(endPoint("/kyc_program/flow")).then(extract);
};

export const fetchApiAdminsData = (
  count,
  offset,
  sort,
  direction,
  email = null,
  roles = [],
  fullName = null,
) => {
  return axios
    .get(
      endPoint("/admins/list", {
        count,
        offset,
        sort,
        direction,
        email,
        roles,
        fullName,
      })
    )
    .then(extract);
};

export const fetchApiUserJournalsData = (
  count,
  offset,
  sort,
  direction,
  email = null,
  ip = null,
  url = null,
  registrationDateFrom = null,
  registrationDateTo = null,
) => {
  return axios
    .get(
      endPoint("/journal/user-logs", {
        count,
        offset,
        sort,
        direction,
        email,
        ip,
        url,
        registrationDateFrom,
        registrationDateTo
      })
    )
    .then(extract);
};

export const fetchTimeZonesData = () => {
  return axios
    .get(endPoint("/admins/time_zones/list"))
    .then(extract)
    .then(parseResult);
};

export const getAdminApiData = (login) => {
  const url = endPoint(`/admins/api_data`, {
    providerLogin: login,
  });
  return axios.get(url).then(extract);
};

export const generateKeys = ({ login, ips }) => {
  const url = endPoint("/admins/generate_keys");
  return axios
    .post(url, {
      providerLogin: login,
      ips,
    })
    .then(extract);
};


export const saveFeeSettings = async ({ clientId, asset, fee, type, value }) => {
  try {
    const response = await axios
      .post(endPoint("/users/save-fee-settings"), { clientId, asset, fee, type, value });
    return response.data.response;
  } catch (error) {
    return null;
  }
};

export const setGroupingInterval = (idp, interval) =>
  axios
    .post(endPoint("/users/grouping_interval"), { idp, interval })
    .then(extract)
    .then(parseResult);

export const setApiSendFlow = (idp, sendflow) =>
  axios
    .post(endPoint("/users/send_flow"), { idp, sendflow })
    .then(extract)
    .then(parseResult);


export const cleanGroupingInterval = (idp) =>
  axios
    .delete(endPoint("/users/grouping_interval", { idp }))
    .then(extract)
    .then(parseResult);

export const cleanApiSendFlow = (idp) =>
  axios
    .delete(endPoint("/users/send_flow", { idp }))
    .then(extract)
    .then(parseResult);

export const getSlcClient = (clientId) =>
  axios
    .post(endPoint("/users/get-slc-client"), { clientId })
    .then(extract)
    .then(parseResult);

export const fetchResetOtp = (idp) => {
  return axios.post(endPoint("/users/reset_otp", { idp })).then(extract);
};

export const fetchResetOtpAdmin = ({ login }) => {
  return axios.post(endPoint("/admins/reset_otp", { login })).then(extract);
};

export const fetchConsolidationData = () =>
  axios
    .get(endPoint("/admin/consolidation_data"))
    .then(extract)
    .then(parseResult);

export const fetchConsolidationMax = (rate) =>
  axios
    .get(endPoint("/admin/consolidation_max", { rate }))
    .then(extract)
    .then(parseResult);

export const fetchDashboardStats = (asset = "btc") =>
  axios
    .get(endPoint(`/dashboard/dashboard-stats/${asset}`))
    .then(extract)
    .then(parseResult);

export const fetchMostActiveWallets = () =>
  axios
    .get(endPoint(`/dashboard/most-active-wallets`))
    .then(extract)
    .then(parseResult);

export const fetchTransactionsCountByDay = () =>
  axios
    .get(endPoint(`/dashboard/transactions-count-by-day`))
    .then(extract)
    .then(parseResult);

export const fetchWalletsCountPerCountry = () =>
  axios
    .get(endPoint(`/dashboard/wallets-count-per-country`))
    .then(extract)
    .then(parseResult);

export const fetchAllRates = () =>
  axios
    .get(endPoint(`/dashboard/get-all-rates`))
    .then(extract)
    .then(parseResult);

export const resetWalletFees = (idp) =>
  axios
    .get(endPoint(`/client-settings/delete-by-idp/${idp}`))
    .then(extract)
    .then(parseResult);

export const fetchWallet = (idp) =>
  axios
    .get(endPoint(`/users/get-by-idp/${idp}`))
    .then(extract)
    .then(parseResult);

export const getUserExcelReport = (idp) =>
  axios.get(endPoint(`/users/get-excel-report/${idp}`), {
    responseType: 'blob',
  }).then(res => res.data);

export const getUserPdfReport = (idp) =>
  axios.get(endPoint(`/users/get-pdf-report/${idp}`), {
    responseType: 'blob',
  }).then(res => res.data);

export const fetchWalletBalances = (idp) =>
  axios
    .get(endPoint(`/users/get-balances-by-idp/${idp}`))
    .then(extract)
    .then(parseResult);

export const withdrawToMain = (idp, asset, fromAddress) =>
  axios
    .get(endPoint(`/users/withdraw-to-main?clientId=${idp}&fromAddress=${fromAddress}&asset=${asset}`))
    .then(extract)
    .then(parseResult);

export const forceUpdateBalancesBalancesForCoinAndClientId = (coin, clientId, address) =>
  axios
    .get(endPoint(`/users/force-update-balances-by-coin-and-client?coin=${coin}&clientId=${clientId}&address=${address}`))
    .then(extract)
    .then(parseResult);

export const apiBumpFee = (idp, txid, fee) =>
  axios
    .post(endPoint("/finance/bump_fee"), { idp, txid, fee })
    .then(extract)
    .then(parseResult);

export const apiEstimateFeeBump = (idp, txid) =>
  axios
    .get(endPoint("/finance/estimate_bump", { idp, txid }))
    .then(extract)
    .then(parseResult);

export const cancelTransaction = (id) =>
  axios
    .put(endPoint(`/withdrawal_request/cancel/${id}`))
    .then(extract)
    .then(parseResult);

export const getTransactionScore = (hash) =>
  axios
    .get(endPoint(`/transactions/score/${hash}`))
    .then(extract)
    .then(parseResult);

export const changeTransactionStatus = (id) =>
  axios
    .put(endPoint(`/withdrawal_request/revert_reviewed/${id}`))
    .then(extract)
    .then(parseResult);

export const fetchTotalBalance = () =>
  axios.post(endPoint(`/admins/balances`)).then(extract).then(parseResult);

export const forceTotalBalanceUpdate = () =>
  axios.post(endPoint(`/admins/balances`)).then(extract).then(parseResult);

export const doUpdateIdpBalance = (idp) =>
  axios
    .post(endPoint(`/admins/balance/${idp}`))
    .then(extract)
    .then(parseResult);

export const fetchUsersAcessCompanyByCompanyId = (companyId) =>
  axios
    .get(endPoint(`/user-access-company/${companyId}`))
    .then(extract)
    .then(parseResult);

export const addUsersAcessCompany = (companyId, { login, phone }) =>
  axios
    .post(endPoint(`/user-access-company/${companyId}`), {
      login,
      phone,
      companyId,
    })
    .then(extract)
    .then(parseResult);

export const deleteUsersAcessCompanyByCompanyId = (id) =>
  axios.delete(endPoint(`/user-access-company/${id}`));

export const fetchPermissions = (count = 100, offset = 0) => {
  return axios
    .get(endPoint(`/acl/permissions`, { count, offset }))
    .then(extract);
};

export const fetchRoles = (count = 100, offset = 0) => {
  return axios.get(endPoint(`/acl/roles`, { count, offset })).then(extract);
};

export const fetchAppliedLimitations = (
  count = 100,
  offset = 0,
  limitation_level = null,
  entity_id = null
) => {
  return axios
    .get(
      endPoint(`/limitations/applied`, {
        limitation_level,
        entity_id,
        count,
        offset,
      })
    )
    .then(extract);
};

export const createAppliedLimitation = ({
  limitation_id,
  limitation_value,
  activity,
  limitation_level,
  entity_id,
  action_on_triggered,
  kyc_program_id,
  applied_tx_asset,
  currency,
}) => {
  return axios
    .post(endPoint("/limitations/applied/create"), {
      limitation_id,
      limitation_value,
      activity,
      limitation_level,
      entity_id,
      action_on_triggered,
      applied_tx_asset,
      kyc_program_id,
      currency,
    })
    .then(extract);
};

export const updateAppliedLimitation = (id, forUpdate) => {
  return axios
    .put(endPoint(`/limitations/applied/update/${id}`), {
      ...forUpdate,
    })
    .then(extract);
};

export const deleteAppliedLimitation = (id) => {
  return axios
    .delete(endPoint(`/limitations/applied/delete/${id}`))
    .then(extract);
};

export const fetchFeeReports = (
  asset,
  year,
  month,
  programs,
  count = 200,
  offset = 0
) => {
  return axios
    .get(
      endPoint(`/fee-reports/generate`, {
        asset,
        year,
        month,
        count,
        offset,
        programs,
      })
    )
    .then(extract);
};

export const fetchLimitations = (count = 100, offset = 0) => {
  return axios
    .get(endPoint(`/limitations/list`, { count, offset }))
    .then(extract);
};

export const createLimitation = ({ name, function_name, description }) => {
  return axios
    .post(endPoint("/limitations/create"), {
      name,
      function_name,
      description,
    })
    .then(extract);
};

export const updateLimitation = (id, forUpdate) => {
  return axios
    .put(endPoint(`/limitations/update/${id}`), {
      ...forUpdate,
    })
    .then(extract);
};

export const deleteLimitation = (id) => {
  return axios.delete(endPoint(`/limitations/delete/${id}`)).then(extract);
};

export const getAssignedPermissionsToRole = (role_id) => {
  return axios
    .get(endPoint(`/acl/get-assigned-permissions/${role_id}`))
    .then(extract);
};

export const assignPermissionToRole = ({ permission_id, role_id }) => {
  return axios
    .post(endPoint("/acl/assign-permission/create"), {
      permission_id,
      role_id,
    })
    .then(extract);
};

export const unAssignPermissionFromRole = ({ permission_id, role_id }) => {
  return axios
    .delete(endPoint("/acl/assign-permission/delete"), {
      data: {
        permission_id,
        role_id,
      },
    })
    .then(extract);
};

export const createRole = ({ name, is_active, description }) => {
  return axios
    .post(endPoint("/acl/roles"), {
      name,
      is_active,
      description,
    })
    .then(extract);
};

export const updateRole = (id, forUpdate) => {
  return axios
    .put(endPoint(`/acl/roles/${id}`), {
      ...forUpdate,
    })
    .then(extract);
};

export const deleteRole = (id) => {
  return axios.delete(endPoint(`/acl/roles/${id}`)).then(extract);
};

export const assignRoleToAdmin = ({ admin_id, role_id }) => {
  return axios
    .post(endPoint("/acl/assign-role/create"), {
      admin_id,
      role_id,
    })
    .then(extract);
};

export const unAssignRoleFromAdmin = ({ admin_id, role_id }) => {
  return axios
    .delete(endPoint("/acl/assign-role/delete"), {
      data: {
        admin_id,
        role_id,
      },
    })
    .then(extract);
};

export const getAssignedRolesToAdmin = (admin_id) => {
  return axios
    .get(endPoint(`/acl/get-assigned-roles/${admin_id}`))
    .then(extract);
};

export const fetchJournals = (
  count,
  offset,
  sort,
  direction,
  searchField = null,
  searchValue = null
) => {
  return axios
    .get(
      endPoint("/journal/list", {
        count,
        offset,
        sort,
        direction,
        searchField,
        searchValue,
      })
    )
    .then(extract);
};

export const fetchNotifications = (props) => {
  return axios
    .get(endPoint("/notifications/find", props))
    .then(extract)
    .then(({ data }) => data);
};

export const fetchNotificationsTemplateById = (id) => {
  return axios
    .get(endPoint(`/notifications-templates/get/${id}`))
    .then(extract)
    .then(({ data }) => data)
    .catch(Promise.reject);
};

export const createNotificationsTemplate = (props) => {
  return axios
    .post(endPoint("/notifications-templates/create"), props)
    .then(extract)
    .then(({ data }) => data)
    .catch(Promise.reject);
};

export const updateNotificationsTemplate = (id, props) => {
  return axios
    .put(endPoint(`/notifications-templates/update/${id}`), props)
    .then(extract)
    .catch(Promise.reject);
};

export const fetchNotificationsTemplates = (props) => {
  return axios
    .get(endPoint("/notifications-templates/find", props))
    .then(extract)
    .then(({ data }) => data);
};

export const fetchNotificationLocales = () => {
  return axios.get(endPoint("/notifications-templates/locals")).then(extract);
};

export const updateNotifications = (id, props) => {
  return axios
    .put(endPoint(`/notifications/update/${id}`), props)
    .then(extract)
    .catch(Promise.reject);
};

export const createCommentTransaction = ({
  enityId: entity_id,
  commentMessage: comment_message,
}) => {
  return axios.post(endPoint("/transactions/comments/create"), {
    entity_type: "transaction",
    entity_id,
    comment_message,
  });
};

export const createCommentDocument = ({
  enityId: entity_id,
  commentMessage: comment_message,
}) => {
  return axios.post(endPoint("/transactions/comments/create"), {
    entity_type: "document",
    entity_id,
    comment_message,
  });
};
export const createCommentCompany = ({
  enityId: entity_id,
  commentMessage: comment_message,
}) => {
  return axios.post(endPoint("/transactions/comments/create"), {
    entity_type: "company",
    entity_id,
    comment_message,
  });
};

export const deleteCommentTransaction = ({ id }) => {
  return axios.delete(endPoint(`/transactions/comments/delete/${id}`));
};

export const updateCommentTransaction = ({
  commentMessage: comment_message,
  id,
}) => {
  return axios.put(endPoint(`/transactions/comments/update/${id}`), {
    comment_message,
  });
};

export const getActivityTypes = () => {
  return axios
    .get(endPoint("/journal/activity_types"))
    .then(extract)
    .then(parseResult);
};

export const addTransactionNote = (num, note) => {
  return axios
    .post(endPoint(`/transactions/comments/create`), {
      entity_type: "transaction",
      entity_id: num,
      comment_message: note,
    })
    .then(extract)
    .then(parseResult);
};

export const getTransactionStatusList = () => {
  return axios
    .get(endPoint(`/transactions/status/list`))
    .then(extract)
    .then(parseResult);
};

export const getTransactionByNum = (num) => {
  return axios
    .get(endPoint(`/transactions/show/${num}`))
    .then(extract)
    .then(parseResult);
};

export const getCompanyById = (id) => {
  return axios
    .get(endPoint(`/companies/${id}`))
    .then(extract)
    .then(parseResult);
};

export const downloadDocWalletFile = (doc_wallet_id) => {
  return axios.get(
    endPoint(`/kyc_program/request/documents/${doc_wallet_id}`),
    {
      responseType: "blob",
    }
  );
};

export const downloadScorechainReportFileItem = (id) => {
  return axios.get(
    endPoint(`/scorechain/download_scorechain_report_file/${id}`),
    {
      responseType: "blob",
    }
  );
};

export const fetchLiquidity = async () => {
  const { balances } = await fetchLiquidityBalances();
  const assetsBalances = Object.entries(balances);

  const assets = await Promise.all(
    assetsBalances.map(async ([asset, balance]) => {
      const { addresses } = await fetchLiquidityAddressAsset(asset);
      return {
        asset,
        address: addresses[asset],
        balance,
      };
    })
  );

  return assets;
};

export const fetchLiquidityBalances = () =>
  axios
    .get(endPoint(`/admin/liquidity/balances`))
    .then(extract)
    .then(parseResult);


export const fetchLastBlocks = () =>
  axios
    .get(endPoint(`/admin/get-last-blocks`))
    .then(extract)
    .then(parseResult);

export const syncBlock = ({ asset }) =>
  axios
    .post(endPoint(`/admin/sync-block`), {
      asset,
    })
    .then(extract)
    .then(parseResult);

export const fetchLiquidityAddressAsset = (asset) =>
  axios
    .get(endPoint(`/admin/liquidity/address/${asset}`))
    // .get(`https://admin-stage.walletallin.com/api/admin/liquidity/address/${asset}`)
    .then(extract)
    .then(parseResult);

export const withdrawLiquidity = ({ asset, amount, address }) =>
  axios
    .post(endPoint(`/admin/withdraw_liquidity`), {
      asset,
      amount,
      address,
    })
    .then(extract)
    .then(parseResult);

export const withdraw = ({ asset, amount, clientId, fromAddress, toAddress }) =>
  axios
    .post(endPoint(`/admin/withdraw`), {
      asset, amount, clientId, fromAddress, toAddress
    })
    .then(extract)
    .then(parseResult);



export const networkFeePrices = ({ asset }) =>
  axios
    .get(endPoint(`/admin/network_fee_prices?asset=${asset}`))
    .then(extract)
    .then(parseResult);

export const approveManualSell = ({ num, amountTo }) =>
  axios
    .post(endPoint(`/manual_sell/approve`), {
      num,
      amountTo,
    })
    .then(extract)
    .then(parseResult);

export const fetchAllDocuments = (clientId) =>
  axios
    .get(endPoint(`/kyc_program/request/list-for-client?clientId=${clientId}`))
    .then(extract)
    .then(parseResult);


export const fetchAllPaymentProviders = () =>
  axios
    .get(endPoint(`/payment-providers/list`))
    .then(extract)
    .then(parseResult);


export const deletePaymentProvider = (id) =>
  axios
    .put(endPoint(`/payment-providers/delete/${id}`))
    .then(extract)
    .then(parseResult);

export const updatePaymentProvider = (id, data) =>
  axios
    .put(endPoint(`/payment-providers/update/${id}`), data)
    .then(extract)
    .then(parseResult);

export const createPaymentProvider = (data) =>
  axios
    .post(endPoint(`/payment-providers/create`), data)
    .then(extract)
    .then(parseResult);

export const fetchAllSites = () =>
  axios
    .get(endPoint(`/sites/list`))
    .then(extract)
    .then(parseResult);

export const createSite = (data) =>
  axios
    .post(endPoint(`/sites/create`), data)
    .then(extract)
    .then(parseResult);

export const updateSite = (id, data) =>
  axios
    .post(endPoint(`/sites/update/${id}`), data)
    .then(extract)
    .then(parseResult);

export const deleteSite = (id) =>
  axios
    .delete(endPoint(`/sites/delete/${id}`))
    .then(extract)
    .then(parseResult);

export const fetchWhitelistedAddresses = (filter) =>
  axios
    .post(endPoint(`/whitelisted-addresses/search`), filter)
    .then(extract)
    .then(parseResult);

export const checkWhitelistedAddress = (address) =>
  axios
    .get(endPoint(`/whitelisted-addresses/check`), {
      params: { address },
    })
    .then(extract)
    .then(parseResult);

export const whitelistAddress = (address) =>
  axios
    .post(endPoint(`/whitelisted-addresses/whitelist`), { address })
    .then(extract)
    .then(parseResult);

export const toggleWhitelistedAddress = (id) =>
  axios
    .patch(endPoint(`/whitelisted-addresses/toggle/${id}`))
    .then(extract)
    .then(parseResult);

export const deleteWhitelistedAddress = (id) =>
  axios
    .delete(endPoint(`/whitelisted-addresses/delete/${id}`))
    .then(extract)
    .then(parseResult);

export const listSumSubAddresses = (includeDeleted = false) =>
  axios
    .get(endPoint(`/sumsub-addresses/list`), { params: { includeDeleted } })
    .then(res => res.data);

export const getSumSubAddressById = (id) =>
  axios
    .get(endPoint(`/sumsub-addresses/get/${id}`))
    .then(extract)
    .then(parseResult);

export const getActiveAddressByChain = (chain) =>
  axios
    .get(endPoint(`/sumsub-addresses/active/${encodeURIComponent(chain)}`))
    .then(res => res.data);

export const createOrReplaceSumSubAddress = ({ address, chain }) =>
  axios
    .post(endPoint(`/sumsub-addresses/create`), { address, chain })
    .then(res => res.data);

export const softDeleteSumSubAddress = (id) =>
  axios
    .put(endPoint(`/sumsub-addresses/delete/${id}`))
    .then(res => res.data);

export const fetchAllQuestionnaires = () =>
  axios
    .get(endPoint(`/questionnaires/list`))
    .then(extract)
    .then(parseResult);

export const createQuestionnaire = (data) =>
  axios
    .post(endPoint(`/questionnaires/create`), data)
    .then(extract)
    .then(parseResult);

export const updateQuestionnaire = (id, data) =>
  axios
    .post(endPoint(`/questionnaires/update/${id}`), data)
    .then(extract)
    .then(parseResult);

export const deleteQuestionnaire = (id) =>
  axios
    .delete(endPoint(`/questionnaires/delete/${id}`))
    .then(extract)
    .then(parseResult);

export const newArch_uploadFile = (file) => {
  let formData = new FormData();
  formData.append("file", file);

  return axios.post('https://daemon.walletallin.com/api/uploader', formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then(extract).then(parseResult);
};

export const updateCustomerLogin = (data) => {
  return axios
    .post(endPoint(`/users/update-login`), data)
    .then(extract)
    .then(parseResult);
};

export const updateCustomerPassword = (data) => {
  return axios
    .post(endPoint(`/users/update-password`), data)
    .then(extract)
    .then(parseResult);
};

export const updateUserLogin = (data) => {
  return axios
    .post(endPoint(`/admins/update-login`), data)
    .then(extract)
    .then(parseResult);
};

export const getRefreshedUser = (clientId) => {
  return axios
    .get(endPoint(`/users/get-refreshed-user`), { params: { clientId } })
    .then(extract)
    .then(parseResult);
};

export const submitTravelRuleTransaction = ({ num }) => {
  return axios
    .post(endPoint(`/transactions/travel-rule-check/${num}`), {})
    .then(extract);
};

export const travelRuleBuy = (trxNum) => {
  return axios
    .post(endPoint(`/transactions/travel-rule-buy-flow`), { trxNum })
    .then(extract);
};

export const exchangeCryptoMonitoring = (trxNum, direction) => {
  return axios
    .post(endPoint(`/transactions/exchange-crypto-monitoring`), { trxNum, direction })
    .then(extract);
};

export const reviewTransactionSumSub = ({ num, reviewAnswer, rejectLabels, clientComment }, host) => {
  const params = new URLSearchParams({ reviewAnswer });

  if (rejectLabels?.length) {
    params.append('rejectLabels', rejectLabels.join(','));
  }

  if (clientComment) {
    params.append('clientComment', clientComment);
  }

  return axios
    .post(
      `${endPoint(`/transactions/sum-sub-review/${num}`)}?${params.toString()}`,
    )
    .then(extract)
    .catch(error => {
      console.error('reviewTransactionSumSub error:', error?.response?.data || error.message);
      return null;
    });
};

export const sendTcoDoc = (num) => {
  return axios
    .post(endPoint(`/transactions/send-tco-doc/${num}`))
    .then(extract)
    .then(parseResult);
};

export const assignProgramToProgram = (programId, parentId) => {
  return axios
    .post(
      endPoint('/kyc_program/assign-program-to-program'),
      {
        program_id: programId,
        parent_id: parentId,
      })
    .then(extract);
};

export const changeStatusFiatToCrypto = ({ num, status }) => {
  return axios
    .post(endPoint(`/transactions/fiat-to-crypto/status/${num}/${status}`))
    .then(extract)
    .catch(error => {
      console.error('changeStatusFiatToCrypto error:', error?.response?.data || error.message);
      return { result: false };
    });
};
